import { reactive, ref, toRefs, computed } from 'vue'
import { Message } from 'view-design'
import { MessageBox } from 'element-ui'
import moment from 'moment'
import { clone, groupBy } from '@/common/js/just.js'
import { MEDIAS } from '@/common/js/constants.js'
import { projectComputedMethods, projectMethods } from '@/views/create/gdt/model/project-mixins.js'
import { getV3PlanForm, getTargetingForm, getMaterialTagForm } from '@/views/create/gdt/model/project-form.js'
import { budgetForm as budgetFormModel } from '@/views/create/gdt/model/budget/budget-form.js'

import { getMaterialTags, removeMaterialTags } from '@/api/tencent.model'
import { getAllMediaTagList } from '@/api/material.model.js'

const planForm = ref({})
const budgetForm = ref({})

export const useProjectForm = () => {
  return {
    planForm,
    budgetForm
  }
}

export const useBudgetForm = () => {
  const budgetModel = reactive({
    showAddMaterialTagModal: false,
    materialTagList: []
  })
  const pageStates = computed(projectComputedMethods.pageStates)

  const materialPackageDisabled = computed(() => {
    return pageStates.value.isEdit
  })

  function onMaterialTagConfirm() { }

  /**
   * @description: 根据账号获取投放素材标签
   */
  function queryMaterialTags() {
    const { accounts } = planForm.value
    const [accountId] = accounts
    if (!accountId) return Message.error('请选择账号')
    getAllMediaTagList({ mediaId: MEDIAS.GDT, accountId }).then((data) => {
      budgetModel.materialTagList = data
    })
  }

  function onMaterialTagChange(id) {
    const item = budgetModel.materialTagList.find((item) => item.tagId === id)
    budgetForm.value.material_package_name = item?.mediaTagName
  }

  function onMaterialTagRemove(id) {
    MessageBox.confirm('确认删除?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
      removeMaterialTags({ ad_account_id: planForm.value.accounts[0], media_label_id: id }).then((data) => {
        queryMaterialTags()
      })
    })
  }

  return {
    ...toRefs(budgetModel),
    pageStates,
    materialPackageDisabled,
    queryMaterialTags,
    onMaterialTagChange,
    onMaterialTagConfirm,
    onMaterialTagRemove
  }
}
